const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/showroom.json`)
const showroom = {...data}

export default showroom